import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { User, UserFilter, PagedResult, Role } from '../../core';

export const UsersPageActions = createActionGroup({
  source: 'Users Page',
  events: {
    'Load Users': props<{ filter?: Partial<UserFilter> }>(),
    Search: props<{ searchTerm: string }>(),
    Sort: props<{ sortField: string }>(),
    'Change Page': props<{ page: number }>(),
    'Change Page Size': props<{ pageSize: number }>(),
    'Filter By Status': props<{ status: boolean | null }>(),
    'Filter By Role': props<{ roleName: string | null }>(),
    'Clear Filters': emptyProps(),
    Refresh: emptyProps(),
    'Load Roles': emptyProps(),
  },
});

export const UsersAPIActions = createActionGroup({
  source: 'Users API',
  events: {
    'Load Users Success': props<{ result: PagedResult<User> }>(),
    'Load Users Failure': props<{ error: string }>(),
    'Load Roles Success': props<{ roles: Role[] }>(),
    'Load Roles Failure': props<{ error: string }>(),
  },
});
